import SharedSpinnerLoad from 'shared_items/SpinnerLoad';

// Shim — shared SpinnerLoad with health module accent (design-system).
const SpinnerLoad = (props) => <SharedSpinnerLoad moduleKey="health" {...props} />;

export default SpinnerLoad;
